import { render } from "./orders.vue?vue&type=template&id=96b2b826&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=96b2b826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b2b826"]])

export default __exports__